export const comics = [
  {
    id: 1,
    slug: 'duzun',
    title: '独尊',
    titleEn: 'The Only One',
    author: '林枫',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: '连载中',
    rating: 9.6,
    views: 35800000,
    chapters: 487,
    description: '天元大陆，强者为尊。少年林辰天赋被夺，沦为废人，却意外获得上古传承，从此踏上逆天改命之路。万族林立，群雄争霸，看他如何一步步踏上巅峰，成为独尊天下的至强者。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manhwa%20style%20cover%20art%2C%20male%20protagonist%20with%20flowing%20dark%20hair%20and%20ancient%20martial%20arts%20robe%2C%20golden%20energy%20surrounding%20his%20body%2C%20dramatic%20lighting%20from%20above%2C%20dark%20atmospheric%20background%20with%20subtle%20mystical%20elements%2C%20Korean%20webtoon%20art%20style%2C%20high%20contrast%2C%20professional%20digital%20illustration&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    tags: ['热血', '玄幻', '逆袭', '战斗'],
    updatedAt: '2026-07-06',
  },
  {
    id: 2,
    slug: 'tianshangdiaoxialai',
    title: '天上掉下来个男朋友',
    titleEn: 'Boyfriend from the Sky',
    author: '苏小暖',
    category: '爱情',
    categorySlug: 'aiqing',
    status: '连载中',
    rating: 9.4,
    views: 28900000,
    chapters: 312,
    description: '普通上班族林小雨某天回家，发现一个陌生帅哥从天而降落在她的阳台上。这个自称来自未来的男人，不仅赖着不走，还说要娶她为妻？一段爆笑又甜蜜的同居生活就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20webtoon%20cover%20art%2C%20handsome%20male%20lead%20and%20cute%20female%20lead%20standing%20close%20together%2C%20soft%20pink%20and%20warm%20lighting%2C%20cherry%20blossom%20petals%20falling%2C%20modern%20city%20background%20at%20sunset%2C%20gentle%20romantic%20atmosphere%2C%20Korean%20manhwa%20art%20style%2C%20clean%20digital%20illustration&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    tags: ['甜宠', '都市', '搞笑', '恋爱'],
    updatedAt: '2026-07-06',
  },
  {
    id: 3,
    slug: 'quannengdashao',
    title: '全能大少',
    titleEn: 'The Almighty Young Master',
    author: '夜独醉',
    category: '热血',
    categorySlug: 'rexue',
    status: '已完结',
    rating: 9.5,
    views: 42100000,
    chapters: 856,
    description: '被人称为废物的叶家三少叶枫，在家族被灭门后觉醒前世记忆。原来他曾是纵横九天十地的绝世强者！如今重活一世，他将以无敌之姿横扫一切，复仇之路就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20action%20manhwa%20cover%2C%20young%20man%20in%20black%20suit%20with%20intense%20gaze%2C%20one%20hand%20emitting%20blue%20energy%2C%20modern%20city%20skyline%20in%20background%20at%20night%2C%20dramatic%20lighting%2C%20powerful%20aura%2C%20dark%20and%20moody%20atmosphere%2C%20Korean%20webtoon%20style%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    tags: ['都市', '热血', '逆袭', '强者回归'],
    updatedAt: '2026-07-05',
  },
  {
    id: 4,
    slug: 'mowangdeqiuyi',
    title: '魔王的囚衣',
    titleEn: "The Demon King's Prisoner",
    author: '墨香铜臭',
    category: '耽美',
    categorySlug: 'danmei',
    status: '连载中',
    rating: 9.7,
    views: 19500000,
    chapters: 234,
    description: '身为光明神殿圣子的洛云，在一次任务中被魔王俘虏。本以为会受尽折磨，却发现魔王对他百般呵护。两个本该势不两立的人，在命运的交织下，谱写出一段禁忌之恋。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20BL%20manhwa%20cover%2C%20two%20elegant%20male%20characters%20facing%20each%20other%2C%20one%20in%20white%20holy%20robes%20the%20other%20in%20dark%20regal%20attire%2C%20ethereal%20lighting%2C%20gothic%20castle%20interior%20background%2C%20dramatic%20contrast%20between%20light%20and%20shadow%2C%20romantic%20tension%2C%20Korean%20webtoon%20art%20style&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    tags: ['古风', '奇幻', '虐恋', '唯美'],
    updatedAt: '2026-07-05',
  },
  {
    id: 5,
    slug: 'xuexiao2026',
    title: '学校2026',
    titleEn: 'School 2026',
    author: '金敏秀',
    category: '校园',
    categorySlug: 'xiaoyuan',
    status: '连载中',
    rating: 9.3,
    views: 16800000,
    chapters: 178,
    description: '2026年的韩国高中，五个性格迥异的少年少女在校园中相遇。友情、暗恋、竞争、梦想，他们共同书写着属于青春的故事。这里有笑有泪，有成长的烦恼也有甜蜜的瞬间。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20school%20life%20manhwa%20cover%2C%20group%20of%20five%20high%20school%20students%20in%20uniforms%20standing%20together%2C%20cherry%20blossom%20trees%20in%20schoolyard%2C%20warm%20spring%20sunlight%2C%20youthful%20and%20energetic%20vibe%2C%20clean%20Korean%20webtoon%20art%20style%2C%20bright%20and%20fresh%20atmosphere&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    tags: ['青春', '友情', '恋爱', '成长'],
    updatedAt: '2026-07-04',
  },
  {
    id: 6,
    slug: 'shenmidiaochaguan',
    title: '神秘调查官',
    titleEn: 'Mystery Investigator',
    author: '暗夜行者',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    rating: 9.2,
    views: 14200000,
    chapters: 203,
    description: '前刑警韩志浩因一次离奇案件被迫离职，成为私家调查官。每一起看似毫无关联的案件背后，都隐藏着一个庞大的阴谋。跟随他的脚步，揭开层层迷雾，探寻真相。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20mystery%20thriller%20manhwa%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%2C%20holding%20a%20flashlight%2C%20dark%20moody%20atmosphere%2C%20neon%20signs%20reflecting%20on%20wet%20ground%2C%20noir%20style%2C%20suspenseful%20tone%2C%20Korean%20webtoon%20art%20style%2C%20dramatic%20shadows&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    tags: ['推理', '都市', '犯罪', '悬疑'],
    updatedAt: '2026-07-04',
  },
  {
    id: 7,
    slug: 'wozaiyijiezuodaodi',
    title: '我在异界做快递',
    titleEn: 'Delivery in Another World',
    author: '笑红尘',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    rating: 9.1,
    views: 22300000,
    chapters: 345,
    description: '快递小哥张伟意外穿越到异世界，本以为要开启龙傲天剧本，却发现这个世界连快递都没有！于是他重操旧业，在异世界开起了快递公司。送快递路上遇到的各种奇葩客户，让人笑到停不下来。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20comedy%20manhwa%20cover%2C%20delivery%20man%20in%20fantasy%20world%20holding%20packages%2C%20surrounded%20by%20confused%20fantasy%20creatures%2C%20bright%20colorful%20fantasy%20landscape%2C%20humorous%20expression%20on%20characters%2C%20lighthearted%20and%20fun%20atmosphere%2C%20Korean%20webtoon%20style&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    tags: ['穿越', '搞笑', '异世界', '日常'],
    updatedAt: '2026-07-03',
  },
  {
    id: 8,
    slug: 'guiyiwusuo',
    title: '诡医无锁',
    titleEn: 'The Uncanny Doctor',
    author: '夜不语',
    category: '恐怖',
    categorySlug: 'kongbu',
    status: '连载中',
    rating: 9.0,
    views: 8700000,
    chapters: 156,
    description: '医学院学生苏瑾在实习期间，发现医院地下隐藏着一个不为人知的秘密。每到午夜，停尸房的尸体总会离奇消失，而第二天又完好无损地出现。当他决定深入调查时，恐怖的事情接连发生……',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20horror%20manhwa%20cover%2C%20dark%20hospital%20corridor%20with%20flickering%20lights%2C%20shadowy%20figure%20in%20the%20distance%2C%20cold%20blue%20and%20dark%20tone%2C%20eerie%20and%20unsettling%20atmosphere%2C%20medical%20themed%20horror%2C%20Korean%20webtoon%20art%20style%2C%20chilling%20digital%20illustration&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    tags: ['恐怖', '医学', '灵异', '惊悚'],
    updatedAt: '2026-07-03',
  },
  {
    id: 9,
    slug: 'xingjizhiwang',
    title: '星际之王',
    titleEn: 'King of the Galaxy',
    author: '星河万里',
    category: '科幻',
    categorySlug: 'kehuan',
    status: '连载中',
    rating: 9.3,
    views: 15600000,
    chapters: 267,
    description: '公元3026年，人类已经遍布银河系。少年林星出身于偏远矿星，在一次星际探索中发现了上古文明的遗迹。获得超时代科技的他，开始了一段波澜壮阔的星际争霸之旅。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20sci-fi%20manhwa%20cover%2C%20young%20space%20commander%20in%20futuristic%20armor%2C%20standing%20in%20spaceship%20bridge%2C%20stars%20and%20galaxies%20visible%20through%20window%2C%20blue%20and%20silver%20color%20scheme%2C%20epic%20space%20opera%20feel%2C%20Korean%20webtoon%20art%20style%2C%20high%20tech%20atmosphere&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    tags: ['科幻', '星际', '冒险', '机甲'],
    updatedAt: '2026-07-02',
  },
  {
    id: 10,
    slug: 'chongshengzhizunvwang',
    title: '重生之尊女皇',
    titleEn: 'Rebirth of the Empress',
    author: '凤歌九天',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: '已完结',
    rating: 9.6,
    views: 31200000,
    chapters: 520,
    description: '一代女皇慕容倾城被亲信背叛，含恨而终。不想竟重生回到十五岁那年。这一世，她不再轻信任何人，手握前世记忆，步步为营，誓要改写命运，让所有背叛者付出代价！',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20manhwa%20cover%2C%20beautiful%20empress%20in%20magnificent%20golden%20and%20red%20royal%20robe%2C%20crown%20on%20her%20head%2C%20sitting%20on%20throne%2C%20imperial%20palace%20background%2C%20regal%20and%20powerful%20aura%2C%20golden%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20luxurious%20digital%20illustration&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    tags: ['重生', '宫廷', '权谋', '女强'],
    updatedAt: '2026-07-02',
  },
  {
    id: 11,
    slug: 'jinpaizhuli',
    title: '金牌助理',
    author: '甜甜圈',
    category: '爱情',
    categorySlug: 'aiqing',
    status: '连载中',
    rating: 9.0,
    views: 9800000,
    chapters: 145,
    description: '刚毕业的苏甜甜阴差阳错成了顶流明星陆琛的私人助理。面对这位脾气古怪的大明星，她每天都在崩溃边缘。然而在朝夕相处中，两人之间微妙的情愫悄然滋生……',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20romantic%20comedy%20manhwa%20cover%2C%20handsome%20male%20celebrity%20and%20cute%20female%20assistant%2C%20backstage%20of%20a%20concert%20venue%2C%20warm%20spotlight%20effect%2C%20playful%20and%20romantic%20chemistry%2C%20modern%20fashion%20style%2C%20Korean%20webtoon%20art%20style&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    tags: ['娱乐圈', '甜宠', '职场', '恋爱'],
    updatedAt: '2026-07-01',
  },
  {
    id: 12,
    slug: 'jiansheng',
    title: '剑圣',
    author: '剑无痕',
    category: '热血',
    categorySlug: 'rexue',
    status: '已完结',
    rating: 9.8,
    views: 52000000,
    chapters: 920,
    description: '剑道天才叶凌云被奸人所害，剑心破碎，沦为废人。十年沉寂，一朝悟道，以凡人之躯重登剑道巅峰。一剑破万法，一剑斩苍穹，这是一个关于剑与不屈的故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20martial%20arts%20manhwa%20cover%2C%20swordsman%20in%20white%20robe%20holding%20a%20glowing%20sword%2C%20standing%20on%20mountain%20peak%2C%20moon%20behind%20him%2C%20dramatic%20wind%20effect%2C%20epic%20and%20heroic%20atmosphere%2C%20traditional%20eastern%20aesthetic%2C%20Korean%20webtoon%20art%20style&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    tags: ['武侠', '剑道', '热血', '逆袭'],
    updatedAt: '2026-07-01',
  },
];

export const featuredComics = comics.filter((c) => c.rating >= 9.4);
export const latestComics = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
export const popularComics = [...comics].sort((a, b) => b.views - a.views);

export function getComicsByCategory(slug: string) {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicBySlug(slug: string) {
  return comics.find((c) => c.slug === slug);
}